/* eslint-disable react/sort-comp */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import * as React from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';

interface IComponentProps extends WrappedComponentProps {
  columns: any;
  action: any;
  label: boolean;
  filterComponent: any;
  reset: any;
  parentState: any;
  actionOpen: any;
  actionSave: any;
  tableName?: string;
  name?: string;
  menuNameOpen: any;
  setStateValue: any;
}

interface IComponentState {
  optionsFromSearch: any;
  searchString: string;
  sentDataLength: number;
}

type Props = IComponentProps;
type State = IComponentState;

const ITEM_LENGTH = 25;

const SimpleSelect = class extends React.PureComponent<Props, State> {
  state: Readonly<State> = {
    optionsFromSearch: [],
    searchString: '',
    sentDataLength: 0,
  };

  constructor(props: Props) {
    super(props);
    this.callReset = this.callReset.bind(this);
    this.callApply = this.callApply.bind(this);
    this.callChecked = this.callChecked.bind(this);
    this.callClick = this.callClick.bind(this);
    this.renderLabel = this.renderLabel.bind(this);
    this.action = this.action.bind(this);
    this.actionOpen = this.actionOpen.bind(this);
    this.handleSearchStringChange = this.handleSearchStringChange.bind(this);
  }

  componentDidMount() {
    const options = this.props.filterComponent.values;
    if (this.state.optionsFromSearch && this.state.optionsFromSearch.length === 0) {
      this.setState({ optionsFromSearch: options });
    }
  }

  componentDidUpdate(prevProps: Props) {
    const options = this.props.filterComponent.values;
    const title = this.props.filterComponent.title;

    if (options !== prevProps.filterComponent.values) {
      this.setState({ optionsFromSearch: options });
      this.setState({ searchString: '' });
    }

    if (
      title !== prevProps.filterComponent.title ||
      (this.props.filterComponent.active !== prevProps.filterComponent.active &&
        this.props.filterComponent &&
        this.props.filterComponent.active === false)
    ) {
      this.setState({ optionsFromSearch: options });
      this.setState({ searchString: '' });
    }

    const column = this.props.parentState.simpleSelect[this.props.columns.name];
    if (column) {
      this.setState({ sentDataLength: Object.values(column).filter((i) => i === true).length });
    }
  }

  actionOpen(e: any) {
    this.props.actionOpen(e, this.props.columns.name);
  }

  action(e: any) {
    this.props.action(this.props.columns.name, e);
  }

  handleSearchStringChange(e: any) {
    const { filterComponent } = this.props;
    const newArrSearch = filterComponent.values.filter((i: any) =>
      i.item
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .includes(
          e.target.value
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
        )
    );
    if (e.target.value !== '') {
      this.setState({ optionsFromSearch: newArrSearch });
    } else {
      this.setState({ optionsFromSearch: filterComponent.values });
    }
    this.setState({ searchString: e.target.value });
  }

  callReset() {
    const { columns } = this.props;
    this.props.reset(columns, 'simpleSelect', true);
    this.setState({ searchString: '' });
    this.setState({ optionsFromSearch: this.props.filterComponent.values });
  }

  callApply(e: any) {
    const { columns, filterComponent } = this.props;
    const sentData: any = [];
    if (
      this.props.parentState.simpleSelect &&
      this.props.parentState.simpleSelect[this.props.columns.name]
    ) {
      const column = this.props.parentState.simpleSelect[this.props.columns.name];
      const columnObject: any = Object.keys(column).map((i) => {
        const key: any = !i ? null : i;
        return { [key]: column[key] };
      });

      Object.values(columnObject).forEach((item: any) => {
        const key = Object.keys(item)[0];
        if (item[key] === true && key === 'null') {
          sentData.push(null);
        } else if (item[key] === true) {
          if (typeof key === 'string') {
            sentData.push(key);
          } else {
            sentData.push(Number(key));
          }
        }
      });
    }
    this.setState({ sentDataLength: sentData.length });

    const id = columns.filter.multiple ? sentData : sentData[0];
    this.props.actionSave(columns.name, id, e, filterComponent.type, columns.title);
  }

  callClick(e: any) {
    const { columns, filterComponent } = this.props;
    const { name, title } = columns;
    const { type } = filterComponent;
    const item = e.currentTarget.getAttribute('data-item');
    const value = e.currentTarget.getAttribute('data-value');
    let newValue: any = Number(value);
    if (value === 'true') {
      newValue = true;
    } else if (value === 'false') {
      newValue = false;
    }
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(newValue) && newValue !== true && newValue !== false) {
      newValue = value;
    }

    if (!filterComponent.multiple) {
      if (Object.keys(this.props.parentState.simpleSelect).length !== 0) {
        this.props.parentState.simpleSelect = {};
      }
      this.props.setStateValue(e, item, true, 'simpleSelect', name);
      // this.props.actionSave(name, [item.value], e, type, title);
      this.props.actionSave(name, filterComponent.multiple ? [newValue] : newValue, e, type, title);
    }
  }

  callChecked(e: any) {
    const { sentDataLength } = this.state;
    this.props.setStateValue(
      e,
      e.currentTarget.value === null || e.currentTarget.value === undefined
        ? null
        : e.currentTarget.value,
      e.currentTarget.checked,
      'simpleSelect',
      this.props.columns.name
    );

    if (e.currentTarget.checked === true) {
      this.setState({ sentDataLength: sentDataLength + 1 });
    } else {
      this.setState({ sentDataLength: sentDataLength - 1 });
    }
  }

  renderLabel() {
    let labelValue = '';
    if (this.props.filterComponent.multiple) {
      if (this.props.filterComponent.selectedValue.length === 1) {
        const filterSelectedValue = !this.props.filterComponent.selectedValue
          ? []
          : this.props.filterComponent.selectedValue;
        // eslint-disable-next-line consistent-return
        labelValue = Object.values(filterSelectedValue).map((item0: any) => {
          const filterComponentItem: any = Object.values(this.props.filterComponent.values).filter(
            (item: any) => String(item.value) === String(item0)
          )[0];
          if (filterComponentItem) {
            return filterComponentItem.item;
          }
        })[0];
      }
      if (
        this.props.filterComponent.selectedValue.length !== 0 &&
        this.props.filterComponent.selectedValue.length !== 1
      ) {
        labelValue = this.props.filterComponent.selectedValue.length;
      }
      if (this.props.filterComponent.selectedValue.length < 2) {
        labelValue += '';
      } else if (this.props.filterComponent.selectedValue.length >= 5) {
        labelValue += ` ${this.props.intl.formatMessage({
          id: 'table.items5',
        })}`;
      } else {
        labelValue += ` ${this.props.intl.formatMessage({
          id: 'table.items2-4',
        })}`;
      }
    } else {
      const filteredComponent = this.props.filterComponent.values.filter(
        (item: any) => item.value === this.props.filterComponent.selectedValue
      )[0];
      if (filteredComponent) {
        labelValue = filteredComponent.item;
      }
    }

    return (
      <span onClick={this.actionOpen}>
        <a
          href="#"
          title={this.props.intl.formatMessage({ id: 'table.filter.button' })}
          data-cy="simple-select-filter-button-dropdown"
          className="dropdown-toggle text-white text-decoration-none"
          id="dropdownMenu13"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
        >
          {this.props.columns.title}: {labelValue}
        </a>
        {(this.props.tableName !== 'gdpr/user' || !this.props.filterComponent?.required) &&
          this.props.filterComponent.title !== 'type' && (
            <a
              href="#"
              data-cy="simple-select-table-filter-remove"
              title={this.props.intl.formatMessage({ id: 'table.filter.remove' })}
              className="text-white"
              onClick={this.action}
              style={{ padding: '8px', margin: '-8px -8px -8px 0' }}
            >
              <i className="cmd-icon cmd-icon-remove-sm" />
            </a>
          )}
      </span>
    );
  }

  render() {
    const { filterComponent, intl, columns } = this.props;
    const { optionsFromSearch } = this.state;
    const column = this.props.parentState.simpleSelect[this.props.columns.name];
    let columnObject: any = [];
    if (column) {
      columnObject = Object.keys(column).map((i) => {
        const key: any = !i ? null : i;
        return { [key]: column[key] };
      });
    }

    return (
      <div
        data-cy={`simple-select-popup-${columns.name}`}
        className={`label ${
          this.props.label ? 'label-primary mb-xs position-relative label--filter' : ''
        }
          ${this.props.menuNameOpen[this.props.columns.name] === this.props.label ? 'open' : ''}`}
        style={{ padding: !this.props.label ? '0px' : '9px 8px 8px 8px' }}
      >
        {this.props.label && <this.renderLabel />}

        <div
          className="dropdown-menu dropdown-menu-custom fs-2 js-dropdown-keep-open"
          aria-labelledby="dropdownMenu10"
          style={{ overflowY: 'hidden' }}
        >
          {filterComponent.filtered && (
            <div className="pt-1 pb-2 px-2 border-bottom-on open">
              <div
                className=" form-control-labels"
                style={{ background: '#fff', border: 'none', color: '#555', padding: '0px' }}
              >
                <input
                  type="text"
                  data-cy="simple-select-filter-input-search"
                  autoFocus={true}
                  onChange={this.handleSearchStringChange}
                  className="form-control font-weight-normal fs-2"
                  placeholder={
                    filterComponent.placeholder
                      ? filterComponent.placeholder
                      : intl.formatMessage({ id: 'form.search' })
                  }
                  value={this.state.searchString}
                  style={{ marginBottom: '10px' }}
                />{' '}
                <div className="chosenItemsInfo" style={{ color: '#808080' }}>
                  {intl.formatMessage({ id: 'form.chosen' })} {this.state.sentDataLength}
                </div>
              </div>
            </div>
          )}
          <div className="scroll-area" style={{ maxHeight: '183px' }}>
            {Object.values(optionsFromSearch).map((item: any, key: any) => (
              <div
                key={key}
                className={`e-checkbox d-block text-black font-weight-normal ${
                  key % 2 !== 0 ? 'bg-select-gray-light' : ''
                }`}
                style={{
                  backgroundColor:
                    filterComponent &&
                    !filterComponent.multiple &&
                    String(filterComponent.selectedValue) === String(item.value)
                      ? //   ||
                        // (columnObject &&
                        //   columnObject.filter((i: any) => i[String(item.value)] === true).length > 0)
                        'rgb(209, 233, 255)'
                      : '',
                }}
                onClick={this.callClick}
                data-cy={`simple-select-filter-select-${item.value}`}
                data-item={item.item}
                data-value={item.value}
              >
                <label className="d-block p-2">
                  {filterComponent.multiple && (
                    <input
                      type="checkbox"
                      data-cy={`simple-select-filter-checkbox-${item.value}`}
                      onChange={this.callChecked}
                      value={item.value === null || item.value === undefined ? null : item.value}
                      checked={
                        columnObject &&
                        columnObject.filter((i: any) => i[String(item.value)] === true).length > 0
                      }
                    />
                  )}
                  {!filterComponent.multiple && item.tooltip ? (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div style={{ flex: '1 1 0%', padding: '0 12px' }}>{item.tooltip}</div>
                      <div style={{ justifyContent: 'flex-end', paddingRight: '12px' }}>
                        {item.item}
                      </div>
                    </div>
                  ) : (
                    <span
                      style={{
                        background: 'none',
                        fontSize: '13px',
                        minHeight: '0',
                      }}
                      title={item.item}
                    >
                      {' '}
                      {item.item && item.item.length > 20
                        ? `${item.item.substring(0, ITEM_LENGTH)} ...`
                        : item.item}
                    </span>
                  )}
                </label>
              </div>
            ))}
          </div>
          {filterComponent.multiple && (
            <div className="row m-0 px-1 py-1 pt-2">
              <div className="col-6 px-xs">
                <a
                  href="#"
                  id="reset"
                  title={intl.formatMessage({ id: 'table.filter.reset' })}
                  data-cy="simple-select-filter-reset-button"
                  className={`e-button d-flex ${
                    (this.state.searchString === '' &&
                      (!this.props.parentState.simpleSelect[this.props.columns.name] ||
                        Object.keys(this.props.parentState.simpleSelect[this.props.columns.name])
                          .length === 0)) ||
                    (this.state.searchString === '' &&
                      this.props.parentState.simpleSelect[this.props.columns.name] &&
                      Object.keys(this.props.parentState.simpleSelect[this.props.columns.name])
                        .length > 0 &&
                      Object.entries(this.props.parentState.simpleSelect[this.props.columns.name])
                        .map((item) => item[1] === true)
                        .filter((item) => item === true).length === 0) // tslint:disable-line
                      ? 'disabled'
                      : ''
                  }`}
                  onClick={this.callReset}
                >
                  Reset
                </a>
              </div>
              <div className="col-6 px-xs">
                <a
                  href="#"
                  title={intl.formatMessage({ id: 'table.apply' })}
                  data-cy="simple-select-filter-apply-button"
                  className={`e-button e-button--gray d-flex ${
                    !this.props.parentState.simpleSelect[this.props.columns.name] ||
                    Object.keys(this.props.parentState.simpleSelect[this.props.columns.name])
                      .length === 0 ||
                    (this.props.parentState.simpleSelect[this.props.columns.name] &&
                      Object.keys(this.props.parentState.simpleSelect[this.props.columns.name])
                        .length > 0 &&
                      Object.entries(this.props.parentState.simpleSelect[this.props.columns.name])
                        .map((item) => item[1] === true)
                        .filter((item) => item === true).length === 0) // tslint:disable-line
                      ? 'disabled'
                      : ''
                  }`}
                  onClick={this.callApply}
                >
                  <FormattedMessage id="table.apply" />
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
};

export default injectIntl(SimpleSelect);
